import { SVGProps } from "react";

export const InactiveStore = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
      <path
        stroke="#3E3E3E"
        strokeLinecap="round"
        strokeWidth={1.125}
        d="M2.225 7.871v3.751c0 2.123 0 3.184.66 3.843.658.66 1.719.66 3.84.66h4.5c2.121 0 3.182 0 3.841-.66.66-.66.66-1.72.66-3.843v-3.75"
      />
      <path
        stroke="#3E3E3E"
        strokeLinecap="round"
        strokeWidth={1.125}
        d="M11.225 12.744c-.513.456-1.33.75-2.25.75-.92 0-1.737-.294-2.25-.75"
      />
      <path
        stroke="#3E3E3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.125}
        d="M7.578 6.313c-.212.764-.98 2.082-2.442 2.273-1.29.168-2.27-.395-2.52-.63-.275-.191-.903-.802-1.057-1.184-.154-.382.026-1.21.154-1.547l.513-1.484c.125-.372.418-1.254.718-1.552.3-.298.908-.311 1.158-.311h5.254c1.353.019 4.31-.012 4.894 0 .585.012.936.502 1.039.712.872 2.113 1.211 3.322 1.211 3.838-.114.55-.585 1.587-2.25 2.043-1.73.474-2.711-.448-3.019-.802m-4.365 0c.244.3 1.008.902 2.116.917 1.107.015 2.064-.758 2.403-1.146.096-.114.304-.454.52-1.127"
      />
    </svg>
  );
};

export const ActiveStore = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
      <path
        stroke="#FF5001"
        strokeLinecap="round"
        strokeWidth={1.125}
        d="M2.225 7.871v3.751c0 2.123 0 3.184.66 3.843.658.66 1.719.66 3.84.66h4.5c2.121 0 3.182 0 3.841-.66.66-.66.66-1.72.66-3.843v-3.75"
      />
      <path
        stroke="#FF5001"
        strokeLinecap="round"
        strokeWidth={1.125}
        d="M11.225 12.744c-.513.456-1.33.75-2.25.75-.92 0-1.737-.294-2.25-.75"
      />
      <path
        stroke="#FF5001"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.125}
        d="M7.578 6.313c-.212.764-.98 2.082-2.442 2.273-1.29.168-2.27-.395-2.52-.63-.275-.191-.903-.802-1.057-1.184-.154-.382.026-1.21.154-1.547l.513-1.484c.125-.372.418-1.254.718-1.552.3-.298.908-.311 1.158-.311h5.254c1.353.019 4.31-.012 4.894 0 .585.012.936.502 1.039.712.872 2.113 1.211 3.322 1.211 3.838-.114.55-.585 1.587-2.25 2.043-1.73.474-2.711-.448-3.019-.802m-4.365 0c.244.3 1.008.902 2.116.917 1.107.015 2.064-.758 2.403-1.146.096-.114.304-.454.52-1.127"
      />
    </svg>
  );
};

export const InactiveSettings = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7647 5.9512L17.3534 5.23737C17.0423 4.69751 16.8868 4.42758 16.6222 4.31994C16.3575 4.21231 16.0582 4.29724 15.4596 4.46711L14.4427 4.75353C14.0606 4.84166 13.6596 4.79166 13.3107 4.61237L13.0299 4.45039C12.7307 4.25873 12.5005 3.97615 12.3731 3.64399L12.0948 2.81284C11.9118 2.26283 11.8203 1.98782 11.6025 1.83052C11.3847 1.67322 11.0954 1.67322 10.5167 1.67322H9.58775C9.00916 1.67322 8.71983 1.67322 8.50199 1.83052C8.2842 1.98782 8.19271 2.26283 8.00974 2.81284L7.73144 3.64399C7.60404 3.97615 7.37387 4.25873 7.07464 4.45039L6.7939 4.61237C6.44494 4.79166 6.04399 4.84166 5.66181 4.75353L4.64495 4.46711C4.04634 4.29724 3.74704 4.21231 3.48239 4.31994C3.21774 4.42758 3.0622 4.69751 2.75112 5.23737L2.3398 5.9512C2.04821 6.45724 1.90241 6.71027 1.93071 6.97962C1.959 7.24897 2.15419 7.46603 2.54455 7.90014L3.40375 8.86071C3.61374 9.12654 3.76284 9.58988 3.76284 10.0065C3.76284 10.4232 3.6138 10.8864 3.40377 11.1523L2.54455 12.1129C2.15419 12.547 1.95901 12.764 1.93071 13.0335C1.90241 13.3028 2.04821 13.5558 2.3398 14.0618L2.75111 14.7756C3.06219 15.3155 3.21774 15.5855 3.48239 15.693C3.74704 15.8007 4.04634 15.7158 4.64497 15.5459L5.66178 15.2595C6.04402 15.1713 6.44505 15.2214 6.79405 15.4007L7.07474 15.5627C7.37392 15.7544 7.60403 16.0369 7.73141 16.369L8.00974 17.2003C8.19271 17.7503 8.2842 18.0253 8.50199 18.1826C8.71983 18.3399 9.00916 18.3399 9.58775 18.3399H10.5167C11.0954 18.3399 11.3847 18.3399 11.6025 18.1826C11.8203 18.0253 11.9118 17.7503 12.0948 17.2003L12.3732 16.369C12.5005 16.0369 12.7306 15.7544 13.0298 15.5627L13.3105 15.4007C13.6595 15.2214 14.0605 15.1713 14.4427 15.2595L15.4596 15.5459C16.0582 15.7158 16.3575 15.8007 16.6222 15.693C16.8868 15.5855 17.0423 15.3155 17.3534 14.7756L17.7647 14.0618C18.0563 13.5558 18.2021 13.3028 18.1738 13.0335C18.1455 12.764 17.9503 12.547 17.56 12.1129L16.7007 11.1523C16.4907 10.8864 16.3417 10.4232 16.3417 10.0065C16.3417 9.58988 16.4908 9.12654 16.7007 8.86071L17.56 7.90014C17.9503 7.46603 18.1455 7.24897 18.1738 6.97962C18.2021 6.71027 18.0563 6.45724 17.7647 5.9512Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M12.9329 10C12.9329 11.6109 11.6271 12.9167 10.0163 12.9167C8.40542 12.9167 7.09961 11.6109 7.09961 10C7.09961 8.38921 8.40542 7.08337 10.0163 7.08337C11.6271 7.08337 12.9329 8.38921 12.9329 10Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const ActiveCustomerManagement = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.48131 12.9013C4.30234 13.6033 1.21114 15.0367 3.09389 16.8305C4.01359 17.7066 5.03791 18.3333 6.32573 18.3333H13.6743C14.9621 18.3333 15.9864 17.7066 16.9061 16.8305C18.7888 15.0367 15.6977 13.6033 14.5187 12.9013C11.754 11.2551 8.24599 11.2551 5.48131 12.9013Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M13.75 5.41669C13.75 7.48775 12.0711 9.16669 10 9.16669C7.92893 9.16669 6.25 7.48775 6.25 5.41669C6.25 3.34562 7.92893 1.66669 10 1.66669C12.0711 1.66669 13.75 3.34562 13.75 5.41669Z"
        stroke="#FF5001"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const ActiveHome = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 14.168C11.8338 14.6866 10.9585 15.0013 10 15.0013C9.04143 15.0013 8.16628 14.6866 7.5 14.168"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M1.95982 11.0126C1.66563 9.09814 1.51854 8.14099 1.88047 7.29245C2.24238 6.4439 3.04535 5.86333 4.65128 4.70219L5.85115 3.83464C7.8489 2.39019 8.84776 1.66797 10.0003 1.66797C11.1528 1.66797 12.1518 2.39019 14.1495 3.83464L15.3493 4.70219C16.9553 5.86333 17.7583 6.4439 18.1202 7.29245C18.4821 8.14099 18.335 9.09814 18.0408 11.0126L17.79 12.645C17.3729 15.3587 17.1644 16.7156 16.1912 17.5251C15.2179 18.3346 13.795 18.3346 10.9493 18.3346H9.05134C6.20561 18.3346 4.78275 18.3346 3.80949 17.5251C2.83623 16.7156 2.62772 15.3587 2.21068 12.645L1.95982 11.0126Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InActiveHome = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 14.168C11.8338 14.6866 10.9585 15.0013 10 15.0013C9.04143 15.0013 8.16628 14.6866 7.5 14.168"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M1.95982 11.0126C1.66563 9.09814 1.51854 8.14099 1.88047 7.29245C2.24238 6.4439 3.04535 5.86333 4.65128 4.70219L5.85115 3.83464C7.8489 2.39019 8.84776 1.66797 10.0003 1.66797C11.1528 1.66797 12.1518 2.39019 14.1495 3.83464L15.3493 4.70219C16.9553 5.86333 17.7583 6.4439 18.1202 7.29245C18.4821 8.14099 18.335 9.09814 18.0408 11.0126L17.79 12.645C17.3729 15.3587 17.1644 16.7156 16.1912 17.5251C15.2179 18.3346 13.795 18.3346 10.9493 18.3346H9.05134C6.20561 18.3346 4.78275 18.3346 3.80949 17.5251C2.83623 16.7156 2.62772 15.3587 2.21068 12.645L1.95982 11.0126Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ActiveProduct = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.083 14.5833V6.25H6.24971C4.28554 6.25 3.30346 6.25 2.69327 6.86018C2.08307 7.47037 2.08306 8.45242 2.08304 10.4167L2.08301 13.75C2.08299 15.7142 2.08298 16.6962 2.69317 17.3065C3.30337 17.9167 4.28547 17.9167 6.24967 17.9167H8.74962C10.321 17.9167 11.1066 17.9167 11.5948 17.4285C12.083 16.9403 12.083 16.1547 12.083 14.5833Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.0835 13.7487H13.7502C15.7144 13.7487 16.6965 13.7487 17.3067 13.1385C17.9169 12.5283 17.9169 11.5462 17.9169 9.58203V6.2487C17.9169 4.28451 17.9169 3.30242 17.3067 2.69222C16.6965 2.08203 15.7144 2.08203 13.7502 2.08203H7.91699L7.91711 6.2487"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M4.58301 10.418H7.49967M4.58301 13.7513H9.58304"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M7.91699 2.08203L12.0837 6.2487"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InActiveProduct = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.083 14.5833V6.25H6.24971C4.28554 6.25 3.30346 6.25 2.69327 6.86018C2.08307 7.47037 2.08306 8.45242 2.08304 10.4167L2.08301 13.75C2.08299 15.7142 2.08298 16.6962 2.69317 17.3065C3.30337 17.9167 4.28547 17.9167 6.24967 17.9167H8.74962C10.321 17.9167 11.1066 17.9167 11.5948 17.4285C12.083 16.9403 12.083 16.1547 12.083 14.5833Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.0835 13.7487H13.7502C15.7144 13.7487 16.6965 13.7487 17.3067 13.1385C17.9169 12.5283 17.9169 11.5462 17.9169 9.58203V6.2487C17.9169 4.28451 17.9169 3.30242 17.3067 2.69222C16.6965 2.08203 15.7144 2.08203 13.7502 2.08203H7.91699L7.91711 6.2487"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M4.58301 10.418H7.49967M4.58301 13.7513H9.58304"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M7.91699 2.08203L12.0837 6.2487"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const InActiveCustomer = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.48131 12.9027C4.30234 13.6047 1.21114 15.0381 3.09389 16.8318C4.01359 17.708 5.03791 18.3347 6.32573 18.3347H13.6743C14.9621 18.3347 15.9864 17.708 16.9061 16.8318C18.7888 15.0381 15.6977 13.6047 14.5187 12.9027C11.754 11.2564 8.24599 11.2564 5.48131 12.9027Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M13.75 5.41797C13.75 7.48904 12.0711 9.16797 10 9.16797C7.92893 9.16797 6.25 7.48904 6.25 5.41797C6.25 3.3469 7.92893 1.66797 10 1.66797C12.0711 1.66797 13.75 3.3469 13.75 5.41797Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const ActiveCustomer = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.48131 12.9027C4.30234 13.6047 1.21114 15.0381 3.09389 16.8318C4.01359 17.708 5.03791 18.3347 6.32573 18.3347H13.6743C14.9621 18.3347 15.9864 17.708 16.9061 16.8318C18.7888 15.0381 15.6977 13.6047 14.5187 12.9027C11.754 11.2564 8.24599 11.2564 5.48131 12.9027Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M13.75 5.41797C13.75 7.48904 12.0711 9.16797 10 9.16797C7.92893 9.16797 6.25 7.48904 6.25 5.41797C6.25 3.3469 7.92893 1.66797 10 1.66797C12.0711 1.66797 13.75 3.3469 13.75 5.41797Z"
        stroke="#FF5001"
        strokeWidth="1.25"
      />
    </svg>
  );
};
export const ActiveOrder = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9.16797C2.5 6.04319 2.5 4.4808 3.29576 3.38553C3.55276 3.0318 3.86383 2.72073 4.21756 2.46373C5.31283 1.66797 6.87522 1.66797 10 1.66797C13.1247 1.66797 14.6872 1.66797 15.7824 2.46373C16.1362 2.72073 16.4472 3.0318 16.7042 3.38553C17.5 4.4808 17.5 6.04319 17.5 9.16797V10.8346C17.5 13.9594 17.5 15.5218 16.7042 16.6171C16.4472 16.9708 16.1362 17.2819 15.7824 17.5389C14.6872 18.3346 13.1247 18.3346 10 18.3346C6.87522 18.3346 5.31283 18.3346 4.21756 17.5389C3.86383 17.2819 3.55276 16.9708 3.29576 16.6171C2.5 15.5218 2.5 13.9594 2.5 10.8346V9.16797Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.4997 7.91797H5.83301M8.33301 12.0846H5.83301"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const InactiveOrder = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9.16797C2.5 6.04319 2.5 4.4808 3.29576 3.38553C3.55276 3.0318 3.86383 2.72073 4.21756 2.46373C5.31283 1.66797 6.87522 1.66797 10 1.66797C13.1247 1.66797 14.6872 1.66797 15.7824 2.46373C16.1362 2.72073 16.4472 3.0318 16.7042 3.38553C17.5 4.4808 17.5 6.04319 17.5 9.16797V10.8346C17.5 13.9594 17.5 15.5218 16.7042 16.6171C16.4472 16.9708 16.1362 17.2819 15.7824 17.5389C14.6872 18.3346 13.1247 18.3346 10 18.3346C6.87522 18.3346 5.31283 18.3346 4.21756 17.5389C3.86383 17.2819 3.55276 16.9708 3.29576 16.6171C2.5 15.5218 2.5 13.9594 2.5 10.8346V9.16797Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.4997 7.91797H5.83301M8.33301 12.0846H5.83301"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ActiveCredit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 9.9987C1.66699 7.0508 1.66699 5.57684 2.54433 4.59278C2.68465 4.43539 2.83931 4.28982 3.00654 4.15776C4.0521 3.33203 5.61818 3.33203 8.75033 3.33203H11.2503C14.3825 3.33203 15.9486 3.33203 16.9941 4.15776C17.1613 4.28982 17.316 4.43539 17.4563 4.59278C18.3337 5.57684 18.3337 7.0508 18.3337 9.9987C18.3337 12.9466 18.3337 14.4205 17.4563 15.4046C17.316 15.562 17.1613 15.7075 16.9941 15.8396C15.9486 16.6654 14.3825 16.6654 11.2503 16.6654H8.75033C5.61818 16.6654 4.0521 16.6654 3.00654 15.8396C2.83931 15.7075 2.68465 15.562 2.54433 15.4046C1.66699 14.4205 1.66699 12.9466 1.66699 9.9987Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M8.33301 13.332H9.58301"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.083 13.332H14.9997"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M1.66699 7.5H18.3337"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InactiveCredit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 9.9987C1.66699 7.0508 1.66699 5.57684 2.54433 4.59278C2.68465 4.43539 2.83931 4.28982 3.00654 4.15776C4.0521 3.33203 5.61818 3.33203 8.75033 3.33203H11.2503C14.3825 3.33203 15.9486 3.33203 16.9941 4.15776C17.1613 4.28982 17.316 4.43539 17.4563 4.59278C18.3337 5.57684 18.3337 7.0508 18.3337 9.9987C18.3337 12.9466 18.3337 14.4205 17.4563 15.4046C17.316 15.562 17.1613 15.7075 16.9941 15.8396C15.9486 16.6654 14.3825 16.6654 11.2503 16.6654H8.75033C5.61818 16.6654 4.0521 16.6654 3.00654 15.8396C2.83931 15.7075 2.68465 15.562 2.54433 15.4046C1.66699 14.4205 1.66699 12.9466 1.66699 9.9987Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M8.33301 13.332H9.58301"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.083 13.332H14.9997"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M1.66699 7.5H18.3337"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InactiveAdmin = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.31705 12.7483C3.26907 13.3625 0.521335 14.6168 2.19489 16.1863C3.01241 16.9529 3.92291 17.5013 5.06763 17.5013H11.5997C12.7444 17.5013 13.6549 16.9529 14.4724 16.1863C16.146 14.6168 13.3982 13.3625 12.3502 12.7483C9.89274 11.3079 6.77454 11.3079 4.31705 12.7483Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M11.6667 5.83333C11.6667 7.67428 10.1742 9.16667 8.33333 9.16667C6.49238 9.16667 5 7.67428 5 5.83333C5 3.99238 6.49238 2.5 8.33333 2.5C10.1742 2.5 11.6667 3.99238 11.6667 5.83333Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
      />
      <path
        d="M16.2503 5.95369V6.66797M16.2503 5.95369C15.6478 5.95369 15.117 5.63801 14.8057 5.1587M16.2503 5.95369C16.8528 5.95369 17.3837 5.63801 17.695 5.1587M14.8057 5.1587L14.1672 5.59654M14.8057 5.1587C14.6216 4.87521 14.5142 4.53449 14.5142 4.16797C14.5142 3.80149 14.6216 3.46081 14.8057 3.17734M17.695 5.1587L18.3334 5.59654M17.695 5.1587C17.8791 4.87521 17.9864 4.53449 17.9864 4.16797C17.9864 3.80149 17.8791 3.46081 17.695 3.17734M16.2503 2.38225C16.8528 2.38225 17.3837 2.69797 17.695 3.17734M16.2503 2.38225C15.6478 2.38225 15.1169 2.69797 14.8057 3.17734M16.2503 2.38225V1.66797M17.695 3.17734L18.3337 2.73939M14.8057 3.17734L14.167 2.73939"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const ActiveAdmin = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.31705 12.7483C3.26907 13.3625 0.521335 14.6168 2.19489 16.1863C3.01241 16.9529 3.92291 17.5013 5.06763 17.5013H11.5997C12.7444 17.5013 13.6549 16.9529 14.4724 16.1863C16.146 14.6168 13.3982 13.3625 12.3502 12.7483C9.89274 11.3079 6.77454 11.3079 4.31705 12.7483Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M11.6667 5.83333C11.6667 7.67428 10.1742 9.16667 8.33333 9.16667C6.49238 9.16667 5 7.67428 5 5.83333C5 3.99238 6.49238 2.5 8.33333 2.5C10.1742 2.5 11.6667 3.99238 11.6667 5.83333Z"
        stroke="#FF5001"
        strokeWidth="1.25"
      />
      <path
        d="M16.2503 5.95369V6.66797M16.2503 5.95369C15.6478 5.95369 15.117 5.63801 14.8057 5.1587M16.2503 5.95369C16.8528 5.95369 17.3837 5.63801 17.695 5.1587M14.8057 5.1587L14.1672 5.59654M14.8057 5.1587C14.6216 4.87521 14.5142 4.53449 14.5142 4.16797C14.5142 3.80149 14.6216 3.46081 14.8057 3.17734M17.695 5.1587L18.3334 5.59654M17.695 5.1587C17.8791 4.87521 17.9864 4.53449 17.9864 4.16797C17.9864 3.80149 17.8791 3.46081 17.695 3.17734M16.2503 2.38225C16.8528 2.38225 17.3837 2.69797 17.695 3.17734M16.2503 2.38225C15.6478 2.38225 15.1169 2.69797 14.8057 3.17734M16.2503 2.38225V1.66797M17.695 3.17734L18.3337 2.73939M14.8057 3.17734L14.167 2.73939"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const InActiveReport = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83301 14.1654V10.832"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M10 14.1654V5.83203"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M14.167 14.168V9.16797"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M2.08301 9.9987C2.08301 6.26675 2.08301 4.40077 3.24237 3.2414C4.40175 2.08203 6.26772 2.08203 9.99967 2.08203C13.7316 2.08203 15.5976 2.08203 16.757 3.2414C17.9163 4.40077 17.9163 6.26675 17.9163 9.9987C17.9163 13.7306 17.9163 15.5966 16.757 16.756C15.5976 17.9154 13.7316 17.9154 9.99967 17.9154C6.26772 17.9154 4.40175 17.9154 3.24237 16.756C2.08301 15.5966 2.08301 13.7306 2.08301 9.9987Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ActiveReport = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83301 14.1654V10.832"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M10 14.1654V5.83203"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M14.167 14.168V9.16797"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M2.08301 9.9987C2.08301 6.26675 2.08301 4.40077 3.24237 3.2414C4.40175 2.08203 6.26772 2.08203 9.99967 2.08203C13.7316 2.08203 15.5976 2.08203 16.757 3.2414C17.9163 4.40077 17.9163 6.26675 17.9163 9.9987C17.9163 13.7306 17.9163 15.5966 16.757 16.756C15.5976 17.9154 13.7316 17.9154 9.99967 17.9154C6.26772 17.9154 4.40175 17.9154 3.24237 16.756C2.08301 15.5966 2.08301 13.7306 2.08301 9.9987Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ActiveAudit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 9.16797V8.33464C15.8333 5.19194 15.8333 3.62059 14.857 2.64428C13.8807 1.66797 12.3093 1.66797 9.16667 1.66797C6.02397 1.66797 4.45262 1.66797 3.47631 2.64428C2.5 3.62059 2.5 5.19194 2.5 8.33464V11.668C2.5 14.8106 2.5 16.3821 3.47631 17.3583C4.45262 18.3346 6.02397 18.3346 9.16667 18.3346"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M17.4997 18.3346L16.0711 16.9061M16.5473 14.5251C16.5473 16.1031 15.2681 17.3822 13.6902 17.3822C12.1122 17.3822 10.833 16.1031 10.833 14.5251C10.833 12.9471 12.1122 11.668 13.6902 11.668C15.2681 11.668 16.5473 12.9471 16.5473 14.5251Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M5.83301 5.83203H12.4997M5.83301 9.16536H9.16634"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const InactiveAudit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 9.16797V8.33464C15.8333 5.19194 15.8333 3.62059 14.857 2.64428C13.8807 1.66797 12.3093 1.66797 9.16667 1.66797C6.02397 1.66797 4.45262 1.66797 3.47631 2.64428C2.5 3.62059 2.5 5.19194 2.5 8.33464V11.668C2.5 14.8106 2.5 16.3821 3.47631 17.3583C4.45262 18.3346 6.02397 18.3346 9.16667 18.3346"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M17.4997 18.3346L16.0711 16.9061M16.5473 14.5251C16.5473 16.1031 15.2681 17.3822 13.6902 17.3822C12.1122 17.3822 10.833 16.1031 10.833 14.5251C10.833 12.9471 12.1122 11.668 13.6902 11.668C15.2681 11.668 16.5473 12.9471 16.5473 14.5251Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M5.83301 5.83203H12.4997M5.83301 9.16536H9.16634"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ActiveCoupon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.06183 17.9282L7.36987 16.924C6.94046 16.6691 6.72575 16.5416 6.48747 16.5343C6.22997 16.5263 6.01146 16.6486 5.54745 16.924C5.02778 17.2325 3.99443 18.0821 3.32602 17.677C2.91699 17.429 2.91699 16.7991 2.91699 15.5394V6.66797C2.91699 4.31094 2.91699 3.13244 3.64923 2.4002C4.38146 1.66797 5.55997 1.66797 7.91699 1.66797H12.0837C14.4407 1.66797 15.6192 1.66797 16.3514 2.4002C17.0837 3.13244 17.0837 4.31094 17.0837 6.66797V15.5394C17.0837 16.7991 17.0837 17.429 16.6747 17.677C16.0062 18.0821 14.9729 17.2325 14.4532 16.924C14.0238 16.6691 13.8091 16.5416 13.5708 16.5343C13.3133 16.5263 13.0948 16.6486 12.6308 16.924L10.9388 17.9282C10.4825 18.1991 10.2542 18.3346 10.0003 18.3346C9.74641 18.3346 9.51816 18.1991 9.06183 17.9282Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.5 6.66797L7.5 11.668"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.5 11.668H12.4925M7.50748 6.66797H7.5"
        stroke="#FF5001"
        strokeWidth="1.66667"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ActiveSettings = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7643 5.94986L17.3529 5.23602C17.0418 4.69617 16.8863 4.42624 16.6217 4.3186C16.357 4.21097 16.0577 4.2959 15.4591 4.46577L14.4423 4.75218C14.0601 4.84032 13.6591 4.79032 13.3102 4.61102L13.0294 4.44905C12.7302 4.25739 12.5 3.97481 12.3726 3.64265L12.0943 2.8115C11.9113 2.26148 11.8198 1.98647 11.602 1.82917C11.3843 1.67187 11.0949 1.67188 10.5163 1.67188H9.58726C9.00867 1.67188 8.71934 1.67187 8.50151 1.82917C8.28371 1.98647 8.19222 2.26148 8.00925 2.8115L7.73095 3.64265C7.60355 3.97481 7.37338 4.25739 7.07415 4.44905L6.79341 4.61102C6.44446 4.79032 6.0435 4.84032 5.66132 4.75218L4.64446 4.46577C4.04585 4.2959 3.74655 4.21097 3.4819 4.3186C3.21725 4.42624 3.06172 4.69617 2.75063 5.23602L2.33932 5.94986C2.04772 6.4559 1.90192 6.70892 1.93022 6.97827C1.95851 7.24762 2.1537 7.46468 2.54406 7.8988L3.40326 8.85937C3.61326 9.1252 3.76235 9.58853 3.76235 10.0051C3.76235 10.4219 3.61331 10.885 3.40328 11.1509L2.54406 12.1115C2.1537 12.5457 1.95852 12.7627 1.93022 13.0321C1.90192 13.3014 2.04772 13.5544 2.33932 14.0604L2.75062 14.7743C3.0617 15.3141 3.21725 15.5841 3.4819 15.6917C3.74655 15.7994 4.04586 15.7144 4.64448 15.5445L5.66129 15.2581C6.04353 15.1699 6.44456 15.22 6.79356 15.3994L7.07426 15.5614C7.37343 15.753 7.60354 16.0355 7.73092 16.3677L8.00925 17.1989C8.19222 17.7489 8.28371 18.0239 8.50151 18.1813C8.71934 18.3385 9.00867 18.3385 9.58726 18.3385H10.5163C11.0949 18.3385 11.3843 18.3385 11.602 18.1813C11.8198 18.0239 11.9113 17.7489 12.0943 17.1989L12.3727 16.3677C12.5 16.0355 12.7301 15.753 13.0293 15.5614L13.31 15.3994C13.659 15.22 14.06 15.1699 14.4423 15.2581L15.4591 15.5445C16.0577 15.7144 16.357 15.7994 16.6217 15.6917C16.8863 15.5841 17.0418 15.3141 17.3529 14.7743L17.7643 14.0604C18.0558 13.5544 18.2016 13.3014 18.1733 13.0321C18.145 12.7627 17.9498 12.5457 17.5595 12.1115L16.7003 11.1509C16.4903 10.885 16.3412 10.4219 16.3412 10.0051C16.3412 9.58853 16.4903 9.1252 16.7003 8.85937L17.5595 7.8988C17.9498 7.46468 18.145 7.24762 18.1733 6.97827C18.2016 6.70892 18.0558 6.4559 17.7643 5.94986Z"
        stroke="#FF5001"
        strokeWidth="1.25"
        stroke-linecap="round"
      />
      <path
        d="M12.9329 9.9987C12.9329 11.6095 11.6271 12.9154 10.0163 12.9154C8.40542 12.9154 7.09961 11.6095 7.09961 9.9987C7.09961 8.38786 8.40542 7.08203 10.0163 7.08203C11.6271 7.08203 12.9329 8.38786 12.9329 9.9987Z"
        stroke="#FF5001"
        strokeWidth="1.25"
      />
    </svg>
  );
};
export const InactiveCatalog = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.083 14.5833V6.25H6.24971C4.28554 6.25 3.30346 6.25 2.69327 6.86018C2.08307 7.47037 2.08306 8.45242 2.08304 10.4167L2.08301 13.75C2.08299 15.7142 2.08298 16.6962 2.69317 17.3065C3.30337 17.9167 4.28547 17.9167 6.24967 17.9167H8.74962C10.321 17.9167 11.1066 17.9167 11.5948 17.4285C12.083 16.9403 12.083 16.1547 12.083 14.5833Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.0835 13.7487H13.7502C15.7144 13.7487 16.6965 13.7487 17.3067 13.1385C17.9169 12.5283 17.9169 11.5462 17.9169 9.58203V6.2487C17.9169 4.28451 17.9169 3.30242 17.3067 2.69222C16.6965 2.08203 15.7144 2.08203 13.7502 2.08203H7.91699L7.91711 6.2487"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M4.58301 10.418H7.49967M4.58301 13.7513H9.58304"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M7.91699 2.08203L12.0837 6.2487"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const InactiveCoupon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.06183 17.9282L7.36987 16.924C6.94046 16.6691 6.72575 16.5416 6.48747 16.5343C6.22997 16.5263 6.01146 16.6486 5.54745 16.924C5.02778 17.2325 3.99443 18.0821 3.32602 17.677C2.91699 17.429 2.91699 16.7991 2.91699 15.5394V6.66797C2.91699 4.31094 2.91699 3.13244 3.64923 2.4002C4.38146 1.66797 5.55997 1.66797 7.91699 1.66797H12.0837C14.4407 1.66797 15.6192 1.66797 16.3514 2.4002C17.0837 3.13244 17.0837 4.31094 17.0837 6.66797V15.5394C17.0837 16.7991 17.0837 17.429 16.6747 17.677C16.0062 18.0821 14.9729 17.2325 14.4532 16.924C14.0238 16.6691 13.8091 16.5416 13.5708 16.5343C13.3133 16.5263 13.0948 16.6486 12.6308 16.924L10.9388 17.9282C10.4825 18.1991 10.2542 18.3346 10.0003 18.3346C9.74641 18.3346 9.51816 18.1991 9.06183 17.9282Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.5 6.66797L7.5 11.668"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.5 11.668H12.4925M7.50748 6.66797H7.5"
        stroke="#3E3E3E"
        strokeWidth="1.66667"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InactiveCreditt = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 9.9987C1.66699 7.0508 1.66699 5.57684 2.54433 4.59278C2.68465 4.43539 2.83931 4.28982 3.00654 4.15776C4.0521 3.33203 5.61818 3.33203 8.75033 3.33203H11.2503C14.3825 3.33203 15.9486 3.33203 16.9941 4.15776C17.1613 4.28982 17.316 4.43539 17.4563 4.59278C18.3337 5.57684 18.3337 7.0508 18.3337 9.9987C18.3337 12.9466 18.3337 14.4205 17.4563 15.4046C17.316 15.562 17.1613 15.7075 16.9941 15.8396C15.9486 16.6654 14.3825 16.6654 11.2503 16.6654H8.75033C5.61818 16.6654 4.0521 16.6654 3.00654 15.8396C2.83931 15.7075 2.68465 15.562 2.54433 15.4046C1.66699 14.4205 1.66699 12.9466 1.66699 9.9987Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M8.33301 13.332H9.58301"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M12.083 13.332H14.9997"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M1.66699 7.5H18.3337"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NoteIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 6.41663C1.75 4.22928 1.75 3.13561 2.30703 2.36892C2.48693 2.12131 2.70468 1.90356 2.95229 1.72366C3.71898 1.16663 4.81266 1.16663 7 1.16663C9.18732 1.16663 10.281 1.16663 11.0477 1.72366C11.2953 1.90356 11.5131 2.12131 11.693 2.36892C12.25 3.13561 12.25 4.22928 12.25 6.41663V7.58329C12.25 9.77062 12.25 10.8643 11.693 11.631C11.5131 11.8786 11.2953 12.0964 11.0477 12.2763C10.281 12.8333 9.18732 12.8333 7 12.8333C4.81266 12.8333 3.71898 12.8333 2.95229 12.2763C2.70468 12.0964 2.48693 11.8786 2.30703 11.631C1.75 10.8643 1.75 9.77062 1.75 7.58329V6.41663Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M8.75004 5.54163H4.08337M5.83337 8.45829H4.08337"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.11098 9.67602C3.22675 10.2025 0.908352 11.2776 2.32041 12.6229C3.0102 13.28 3.77843 13.75 4.7443 13.75H10.2557C11.2216 13.75 11.9898 13.28 12.6796 12.6229C14.0916 11.2776 11.7733 10.2025 10.889 9.67602C8.8155 8.44133 6.1845 8.44133 4.11098 9.67602Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
        stroke-linecap="round"
        strokeLinecap="round"
      />
      <path
        d="M10.3125 4.0625C10.3125 5.6158 9.05331 6.875 7.5 6.875C5.9467 6.875 4.6875 5.6158 4.6875 4.0625C4.6875 2.5092 5.9467 1.25 7.5 1.25C9.05331 1.25 10.3125 2.5092 10.3125 4.0625Z"
        stroke="#3E3E3E"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M6 14V8H0V6h6V0h2v6h6v2H8v6H6Z" />
  </svg>
);
